import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const OuterWrapper = styled(Box)(`
    padding-top:10px;
`)

export const Error = styled(Box)(`
    font-size:13px;
    color:red;
`)

export const Message = styled(Box)(`
    font-size:13px;
    color:green;
`)

export const ButtonWrapper = styled(Box)(`
    display: flex;
    justify-content: end;
    align-items: center;
    margin-bottom: 20px;
    width: 100%
`)
